// extracted by mini-css-extract-plugin
export default {"container":"PrefixTriggeredMenu-module__container--RJJth","small":"PrefixTriggeredMenu-module__small--xxLM-","reference":"PrefixTriggeredMenu-module__reference--DVy50"};